var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 400,
    viewBox: "0 0 385 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3925_40246)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.417 142.335L374.902 155.378C381.209 160.409 384.887 168.034 384.899 176.101V372.206C384.899 386.832 373.043 398.689 358.417 398.689H27.3822C12.7561 398.689 0.899414 386.832 0.899414 372.206V176.101C0.912014 168.034 4.59024 160.409 10.8967 155.378L27.3822 142.335H358.417Z",
    fill: "url(#paint0_linear_3925_40246)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3789 330.762V27.9313C27.4007 20.6274 33.3163 14.7118 40.6203 14.6899H345.172C352.476 14.7118 358.392 20.6274 358.413 27.9313V323.876L27.3789 330.762Z",
    fill: "url(#paint1_linear_3925_40246)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3925_40246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.892 179.58H262.111C268.033 179.58 272.852 174.761 272.852 168.839V111.551C272.852 105.629 268.033 100.81 262.111 100.81H118.892C112.97 100.81 108.15 105.629 108.15 111.551V168.839C108.15 174.761 112.97 179.58 118.892 179.58ZM115.311 111.551C115.311 109.575 116.915 107.97 118.892 107.97H262.111C264.087 107.97 265.692 109.575 265.692 111.551V168.839C265.692 170.815 264.087 172.419 262.111 172.419H118.892C116.915 172.419 115.311 170.815 115.311 168.839V111.551Z",
    fill: "#D4EFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.657 145.912C124.079 146.55 124.779 146.893 125.487 146.893C125.905 146.893 126.327 146.774 126.706 146.523L129.887 144.402V149.093C129.887 150.307 130.873 151.293 132.087 151.293C133.301 151.293 134.287 150.307 134.287 149.093V144.403L137.468 146.523C137.842 146.774 138.264 146.893 138.682 146.893C139.395 146.893 140.09 146.55 140.517 145.912C141.19 144.9 140.918 143.536 139.906 142.863L136.051 140.293L139.906 137.723C140.918 137.05 141.19 135.686 140.517 134.674C139.844 133.662 138.48 133.389 137.468 134.063L134.287 136.183V131.493C134.287 130.279 133.301 129.293 132.087 129.293C130.872 129.293 129.887 130.279 129.887 131.493V136.183L126.705 134.062C125.689 133.389 124.325 133.662 123.656 134.674C122.983 135.686 123.256 137.05 124.268 137.723L128.122 140.293L124.268 142.863C123.256 143.536 122.983 144.9 123.657 145.912Z",
    fill: "#90B4A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.656 145.912C147.079 146.55 147.778 146.893 148.487 146.893C148.905 146.893 149.327 146.774 149.706 146.523L152.887 144.402V149.093C152.887 150.307 153.872 151.293 155.087 151.293C156.301 151.293 157.287 150.307 157.287 149.093V144.403L160.468 146.523C160.842 146.774 161.264 146.893 161.683 146.893C162.395 146.893 163.091 146.55 163.517 145.912C164.191 144.9 163.918 143.536 162.906 142.863L159.051 140.293L162.906 137.723C163.918 137.05 164.191 135.686 163.517 134.674C162.844 133.662 161.48 133.389 160.468 134.063L157.287 136.183V131.493C157.287 130.279 156.301 129.293 155.087 129.293C153.872 129.293 152.887 130.279 152.887 131.493V136.183L149.706 134.063C148.689 133.389 147.325 133.662 146.656 134.674C145.983 135.686 146.256 137.05 147.268 137.723L151.122 140.293L147.268 142.863C146.256 143.536 145.983 144.9 146.656 145.912Z",
    fill: "#90B4A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.656 145.911C170.079 146.549 170.778 146.892 171.487 146.892C171.905 146.892 172.327 146.774 172.706 146.523L175.887 144.402V149.092C175.887 150.307 176.872 151.292 178.087 151.292C179.301 151.292 180.287 150.307 180.287 149.092V144.402L183.468 146.523C183.842 146.774 184.264 146.893 184.683 146.893C185.395 146.893 186.091 146.549 186.517 145.911C187.191 144.899 186.918 143.535 185.906 142.862L182.051 140.292L185.906 137.723C186.918 137.05 187.191 135.686 186.517 134.674C185.844 133.662 184.48 133.389 183.468 134.062L180.287 136.183V131.493C180.287 130.278 179.301 129.292 178.087 129.292C176.872 129.292 175.887 130.278 175.887 131.492V136.183L172.706 134.062C171.689 133.389 170.325 133.662 169.656 134.673C168.983 135.685 169.256 137.049 170.268 137.723L174.122 140.292L170.268 142.862C169.256 143.535 168.983 144.899 169.656 145.911Z",
    fill: "#90B4A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.656 145.912C216.079 146.55 216.778 146.893 217.487 146.893C217.905 146.893 218.327 146.774 218.706 146.524L221.887 144.403V149.093C221.887 150.308 222.872 151.293 224.087 151.293C225.301 151.293 226.287 150.308 226.287 149.093V144.403L229.468 146.524C229.842 146.775 230.264 146.894 230.683 146.894C231.395 146.894 232.091 146.55 232.517 145.912C233.191 144.9 232.918 143.536 231.906 142.863L228.051 140.293L231.906 137.724C232.918 137.051 233.191 135.687 232.517 134.675C231.844 133.662 230.48 133.39 229.468 134.063L226.287 136.184V131.494C226.287 130.279 225.301 129.293 224.087 129.293C222.872 129.293 221.887 130.279 221.887 131.493V136.184L218.706 134.063C217.689 133.39 216.325 133.662 215.656 134.674C214.983 135.686 215.256 137.05 216.268 137.724L220.122 140.293L216.268 142.863C215.256 143.536 214.983 144.9 215.656 145.912Z",
    fill: "#90B4A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.656 145.599C239.079 146.237 239.778 146.58 240.487 146.58C240.905 146.58 241.327 146.462 241.706 146.211L244.887 144.09V148.78C244.887 149.995 245.872 150.98 247.087 150.98C248.301 150.98 249.287 149.995 249.287 148.78V144.09L252.468 146.211C252.842 146.462 253.264 146.581 253.683 146.581C254.395 146.581 255.091 146.237 255.517 145.599C256.191 144.587 255.918 143.223 254.906 142.55L251.051 139.98L254.906 137.411C255.918 136.738 256.191 135.374 255.517 134.362C254.844 133.349 253.48 133.077 252.468 133.75L249.287 135.871V131.181C249.287 129.966 248.301 128.98 247.087 128.98C245.872 128.98 244.887 129.966 244.887 131.18V135.871L241.706 133.75C240.689 133.077 239.325 133.349 238.656 134.361C237.983 135.373 238.256 136.737 239.268 137.411L243.122 139.98L239.268 142.55C238.256 143.223 237.983 144.587 238.656 145.599Z",
    fill: "#90B4A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.656 145.599C193.079 146.237 193.778 146.58 194.487 146.58C194.905 146.58 195.327 146.462 195.706 146.211L198.887 144.09V148.78C198.887 149.995 199.872 150.98 201.087 150.98C202.301 150.98 203.287 149.995 203.287 148.78V144.09L206.468 146.211C206.842 146.462 207.264 146.581 207.683 146.581C208.395 146.581 209.091 146.237 209.517 145.599C210.191 144.587 209.918 143.223 208.906 142.55L205.051 139.98L208.906 137.411C209.918 136.738 210.191 135.374 209.517 134.362C208.844 133.349 207.48 133.077 206.468 133.75L203.287 135.871V131.181C203.287 129.966 202.301 128.98 201.087 128.98C199.872 128.98 198.887 129.966 198.887 131.18V135.871L195.706 133.75C194.689 133.077 193.325 133.349 192.656 134.361C191.983 135.373 192.256 136.737 193.268 137.411L197.122 139.98L193.268 142.55C192.256 143.223 191.983 144.587 192.656 145.599Z",
    fill: "#90B4A5"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.647 177.152L385.647 369.748C385.678 377.264 380.924 387.708 375.296 392.69L249.296 293.09L385.647 177.152Z",
    fill: "url(#paint2_linear_3925_40246)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.092 391.872C371.248 396.256 364.948 398.686 358.415 398.692H27.3804C20.8467 398.686 14.5476 396.256 9.70312 391.872L134.569 294.813L184.688 255.883C189.51 252.109 196.285 252.109 201.107 255.883L251.226 294.813L376.092 391.872Z",
    fill: "url(#paint3_linear_3925_40246)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.569 294.811L9.70321 391.871C4.07476 386.889 0.865978 379.723 0.897694 372.207L0.897461 179.611L134.569 294.811Z",
    fill: "url(#paint4_linear_3925_40246)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3925_40246",
    x1: 344.9,
    y1: 374.096,
    x2: 135.44,
    y2: 55.2416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BAF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E1BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3925_40246",
    x1: 192.896,
    y1: 14.6899,
    x2: 192.896,
    y2: 330.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4F2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3925_40246",
    x1: 371.723,
    y1: 369.048,
    x2: 200.128,
    y2: 259.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E1BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3925_40246",
    x1: 338.677,
    y1: 382.717,
    x2: 251.756,
    y2: 161.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E1BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3925_40246",
    x1: 120.919,
    y1: 368.589,
    x2: -47.7445,
    y2: 261.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E1BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3925_40246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 398.59,
    fill: "white",
    transform: "translate(0.899414 0.975586)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3925_40246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164.702,
    height: 164.702,
    fill: "white",
    transform: "translate(108.15 57.8442)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.0f7a3b10.svg";
export { ForwardRef as ReactComponent };